import LocalizedStrings from 'react-localization';

class Globalization extends LocalizedStrings {
  setLanguage(language) {
    if (!language) {
      language = navigator.language || 'en';
    }
    super.setLanguage(language);
  }
}
export default new Globalization({
  en: {
    Welcome: 'Welcome to CAT License',
    ListFetchFailed: 'Error occures while fetching the List',
    FetchFailed: 'Error occures while fetching the record',
    ComboFetchFailed: 'Error occures while fetching the combo',
    DeleteFailed: 'Delete Failed',
    SessionExpire: 'Session Expired',
    AddFailed: 'Add Failed',
    LoadFailed: 'Record Load Failed',
    ListFailed: 'List Load Failed',
    UpdateFailed: 'Update Failed',
    Duplicate_ClientName: 'Duplicate Client Name',
    Duplicate_MachineKey: 'Duplicate Machine Key',
    InvalidActionType: 'Invalid Action Type',
    RequestError: 'Request Error',
    InvalidUser: 'Non-Active or Invalid User',
    InvalidRequest: 'Invalid Request',
    Yes: 'Yes',
    No: 'No',
    Active: 'Active',
    Payload: 'Payload',
    All: 'All',
    CAT: 'CAT License Rev',
    Copyright: 'Copyright',
    SterisCorporation: 'Steris Corporation',
    DisplayingRecord: 'Displaying record',
    RowsPerPage: 'Rows Per Page',
    RecordSavedSuccessfully: 'Record Saved Successfully',
    RecordUpdatedSuccessfully: 'Record Updated Successfully',
    Success: 'Success',
    Warning: 'Warning',
    Info: 'Info',
    Password_Missing: 'Password Missing',
    LightTheme: 'Light Mode',
    DarkTheme: 'Dark Mode',
    ConfirmPasswordAlert: 'Password does not match to Confirm Password',
    DeleteWarning: 'Are you sure?',
    DeleteText: `You won't be able to revert this!`,
    DeleteConfirmButton: 'Yes, delete it!',
    DeleteSuccess: 'Record successfully deleted',
    Alert: 'Alert',
    InternalServerError: 'Internal Server Error',
    ServerOverload:
      'Server is currently unable to handle request due to temporary overload or maintenance',
    ServerUnavailable: 'Server - unavailable',
    BadRequest: 'Bad Request',
    Error: 'Error',
    UnhandledException: 'Something went wrong',
    ThemeUpdateFailed: 'Theme Update Failed',
    Duplicate_UserName: `Username cannot be duplicate`,
    Duplicate_Email: `Email cannot be duplicate`,
    RequestTimeoutError: `Please check your Network Connection`,
    LicenceDownloadFailed: 'Licence Download Failed',
    AccountLocked:
      'Your account is locked.<br/> Please contact to administrator.',
    InvalidEmail: 'Invalid email address',
    PasswordValidationError:
      'Password length should be between 8 to 50 and must contain atleast 1 lowercase 1 uppercase 1 number and 1 special character',
    VersionWarn: 'You are going to create license for application below 3.3.',
    StatusWarn:
      'You are going to Deactivate the license. This license will not be available to download.',
    ResetPasswordSuccess: 'Password reset successfully.',
    ResetPassword: 'Reset Password',
    InactiveLicense: 'Inactive Hospital license cannot be downloaded',
    DuplicateSerial:
      '<p style="margin-left:3.6em; text-align:justify;">Please make sure:<br/>1. No duplicate values are there.<br/>2. Extra blank spaces like ",,".<br/>3. Extra comma at the end of Serial Number\'s</p>',
    HospitalLogoWarning: 'Hospital Logo must be less than or equal to 50kb',
    LicenseDownloadButton:
      'No Equipment Added Yet, Please Add Equipment to Download License',
    LicensePopUp:
      'The license will generate in the pop up window. Please allow pop ups in order to have the license downloaded.',

    //Buttons
    FilterText: 'Filters',
    Add: 'Add',
    Delete: 'Delete',
    Download: 'Download',
    DownloadCertificate: 'Download Certificate',
    Save: 'Save',
    Cancel: 'Cancel',
    Login: 'Login',
    Refresh: 'Refresh',
    LogOut: 'Sign Out',
    Reset: 'Reset',
    Column: 'Columns',
    Apply: 'Apply',
    Submit: 'Submit',
    History: 'History',
    GenerateCertificate: 'Download Client Certificate',
    CertificateInformation:
      'Please enter the Mac address of your system to get the client certificate',

    //Menus
    ManageLicense: 'Manage License',
    ManageUser: 'Manage User',
    Reports: 'Reports',
    Configurations: 'Configurations',

    //Forms name
    LicenseForm: 'License Details',
    UserForm: 'User Details',

    //Grid/Form Columns/Fields Name
    UserName: 'User Name',
    FirstName: 'First Name',
    LastName: 'Last Name',
    Email: 'Email',
    Password: 'Password',
    ConfirmPassword: 'Confirm Password',
    Tries: 'Wrong Attempts',
    UserRole: 'Role',
    CreatedOn: 'Created On',
    HospitalName: 'Hospital Name',
    HospitalAddress: 'Hospital Address',
    ClientId: 'Client Id',
    EquipmentSerial: 'Equipment Serial',
    ProductType: 'Product Type',
    LicenseType: 'License Type',
    CatSyncVersion: 'Cat Sync Version',
    CatViewerVersion: 'CAT Viewer Version',
    CatVersion: 'CAT Version',
    CatSyncVersion: 'CAT Sync Version',
    CatSoftwareVersion: 'CAT Software Version',
    Version: 'Version',
    DefaultLanguage: 'Default Language',
    LicStatus: 'Status',
    updatedAt: 'Updated On',
    CreatedBy: 'Created By',
    UpdatedBy: 'Updated By',
    Actions: 'Actions',
    DownloadAction: 'Download Certificates',
    SyncSchedule: 'Sync To Cloud(In Min)',
    MachineKey: 'Machine Key',
    EquipmentSerials: 'Equipment Serial Number(s)',
    HospitalLogo: 'Hospital Logo',
    Unlocked: 'Unlocked',
    Locked: 'Locked',
    Status: 'Account Status',
    LockedAlert:
      'Account cannot be locked manually.<br/> Account will be locked after 5 consecutive login failures.',
    ModelName: 'Model Name',
    EquipmentFamily: 'Equipment Family',
    ExportEquipmentFamily: 'Data Export Equipment Family',
    PasswordView: 'View Password',

    //Site Form
    AddressId: 'Address ID',
    Duplicate_AddressId: 'Address ID cannot be duplicate',
    Site: 'Site',
    SiteForm: 'Site Form',
    SiteName: 'Site Name',
    Region: 'Region',
    Dealer: 'Dealer',
    IDN: 'IDN',
    AccountNumber: 'Account Number',
    InitialSOA: 'Initial SOA',
    MostRecentSOA: 'SOA',
    Notes: 'Notes',
    Logo: 'Logo',
    LogoWarning: 'Logo must be less than or equal to 50kb',
    SaveContinue: 'Save and Continue',
    Country: 'Country',
    State_Province_Region: 'State/Province',
    City: 'City',
    SubRegion: 'Sub Region',
    SiteAddress1: 'Site Address 1',
    SiteAddress2: 'Site Address 2',
    PostalCode: 'Postal Code',
    CountryCode: 'Country Code',
    TimeZone: 'Time Zone',
    State: 'State',
    downloadMessage:
      'Please enter Address ID, City, State, Country Code, Common Name, Organization Unit, Email Adress on site form',
    PhoneNumber: 'Phone Number',

    //Equipment Form/List
    Equipment: 'Equipment',
    SerialNumber: 'Serial Number',
    ExpirationDate: 'Expiration Date',
    EquipmentModel: 'Equipment Model',
    EquipmentName: 'Equipment Name',
    EquipmentType: 'Equipment Type',
    AccessLocation: 'Access Location',
    ConnectivityType: 'Connectivity Type',
    TransferPDF: 'Transfer PDF',
    EquipmentState: 'Equipment State',
    DateDeactivated: 'Date Deactivated',
    SerialNo: 'Serial No',
    Type: 'Type',
    ModifiedOn: 'Modified On',
    ModifiedBy: 'Modified By',
    AddEquipment: 'Add Equipment',
    Name: 'Name',
    Duplicate_SerialNumber: 'Serial Number cannot be duplicate',
    NotesModifiedBy: 'Notes Modified By',
    NotesModifiedDate: 'Notes Modified Date',
    MachineNumber: 'Machine #',
    Language: 'Language',
    DataType: 'Data Type',
    DeviceType: 'Device Type',
    Endo: 'Endo',

    //License Form
    GracePeriod: 'Grace Period (In Days)',
    HardPeriod: 'Hard Period (In Days)',
    EditSite: 'Edit Site',
    Duplicate_Name: 'Name cannot be duplicate',
    Duplicate_AccountNumber: 'Account Number cannot be duplicate',
    Duplicate_MachineKey: 'Machine Key cannot be duplicate',
    DownloadLicense: 'Generate/Download License',
    // InactiveLicense: 'Inactive license cannot be downloaded',
    InActiveEquipments:
      'Atleast one equipment should be active to generate file',

    //History List
    FieldUpdated: 'Field Updated',
    OriginalValue: 'Original Value',
    NewValue: 'New Value',
    TableName: 'Table Name',
    Back: 'Go Back',

    //Preference
    Preferences: 'Preferences',
    AddPreference: 'Add Preference',
    ManagePreference: 'Manage Preferences',
    Description: 'Description',
    IsDefault: 'Is Default',
    Close: 'Close',
    Modify: 'Modify',
    Default: 'Default',
    DefaultPrefWarning:
      'If you set this as default preference. Your old default preference would be overridden.',

    //Report Form
    Report: 'Report',
    Format: 'Format',
    StartDate: 'Start Date',
    EndDate: 'End Date',
    ReportDetails: 'Report Details',
    GenerateReportFailed: 'Generate report failed',

    UniqueId: 'Unique ID',
    New: 'New',
    AddFacility: 'Add Facility',
    AddModel: 'Add Model',
    AddLicense: 'Add License',
    EquipmentWarning:
      'Equipment(s) will not be considered for this Product type(s)',
    TestUrl: 'Test URL',
    AccessUrlNotFound: 'Cannot Find Specified Access Url',
    FileOrDirectoryNotFound: 'FIle or Directory Not Found',

    // Certificate Config Form
    CertificateDetail: 'Certificate Detail',
    GenerateCSR: 'Certificate Information',
    CertificateType: 'Certificate Type',
    Organization: 'Organization',
    Locality: 'Locality',
    CommonName: 'Common Name',
    OrganizationalUnit: 'Organizational Unit',
    Unit: 'Unit',
    EmailAddress: 'Email Address',
    CountryName: 'Country Name',
    ServerCertificate: 'Server Certificate',
    ClientCertificate: 'Client Certificate',
    MacAddress: 'Mac Address',
    DeviceName: 'Device Name',
    Letter2: ' (2 letter code)',
    Certificates: 'Certificates',
    User: 'User',
    NoRecordsFound: 'No records found Please change the criteria',
    FQDN: 'FQDN',
    ClientCommonName: 'MAC Address',

    //Model Form/List,
    Duplicate_ModelName: 'Model Name cannot be duplicate',
    WellCount: 'Number of Wells',
    CycleLength: 'Cycle Length',
    DateFormat: 'Date Format',
    Duplicate_EquipmentName: 'Equipment Name cannot be duplicate',
    Duplicate_AddressId: 'Address Id cannot be duplicate',
    Endo: 'Endo',
    Hulu: 'Hulu',
    UserRFID: 'User RFID',
    ScopeRFID: 'Scope RFID',
    SCMModel: 'SCM Model',
    TrackingSystemName: 'Tracking System Name',
    AddCATSoftwareVersion: 'Add CAT Software Version',
    CompanyName: 'Company Name',
    ContactName: 'Contact Name',
    ContactEmail: 'Contact Email',
    CompanyAddress: 'Company Address',
    TrackingSystem: 'Tracking System',
    Duplicate_TrackingSystemName: 'Tracking System Name cannot be duplicate',
    Duplicate_ContactEmail: 'Contact Email cannot be duplicate',
    TrackingSystemLinkedToFacility:
      "Tracking System can't be deleted with a site linked to it.",
    CATSoftwareVersionLinkedToLicense:
      "The CAT Software version is linked to a license and therefore, can't be deleted.",
    CompanyAddress1: 'Company Address 1',
    CompanyAddress2: 'Company Address 2',
    ContactLinkedToTrackingSystem:
      "The contact is linked to a tracking system and therefore, can't be deleted.",
    TrackingSystemContacts: 'Tracking System Contacts',
    AddContact: 'Add Contact',
    Duplicate_ContactName: 'Contact Name cannot be duplicate'
  }
});
